import { useEffect, useState } from 'react';

export function useRafRender() {
  const [entered, setEntered] = useState(false);

  useEffect(() => {
    const handle = requestAnimationFrame(() => {
      setEntered(true);
    });

    return () => {
      cancelAnimationFrame(handle);
    };
  }, []);

  return entered;
}
